import { optionalStringArraySearchSchema } from '@/lib/optionalStringArraySearchSchema';
export const equipmentAlertFilterFields = {
  equipmentTypeIdIn: optionalStringArraySearchSchema,
  equipmentItemIdIn: optionalStringArraySearchSchema,
  placementPlaceIdIn: optionalStringArraySearchSchema
};